import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import { SEO } from '../../utils/seo';

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "ボディケア専門店H&K",
    "description": "福島県いわき市のストレッチ専門店。身体の不調、肩こり、腰痛、眼精疲労でお困りの方へ。PNFストレッチ、パーソナルトレーニングで理想のカラダづくりをサポート。",
    "url": import.meta.env.VITE_SITE_URL,
    "telephone": "+81-246-123-4567",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "平字三町目1-1",
      "addressLocality": "いわき市",
      "addressRegion": "福島県",
      "postalCode": "970-8026",
      "addressCountry": "JP"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 37.0569,
      "longitude": 140.8891
    },
    "openingHours": [
      "Mo-Fr 09:00-21:00",
      "Sa 09:00-18:00"
    ],
    "priceRange": "¥¥",
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 37.0569,
        "longitude": 140.8891
      },
      "geoRadius": "50000"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "ストレッチ・ボディケアサービス",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "PNFストレッチ",
            "description": "専門的なストレッチ技術で筋肉の柔軟性を向上"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "パーソナルトレーニング",
            "description": "個人に合わせたトレーニングプログラム"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "ボディケア",
            "description": "肩こり、腰痛、眼精疲労の改善"
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="ボディケア専門店H&K - 理想のカラダに。パーソナルストレッチ専門店"
        description="福島県いわき市のストレッチ専門店。身体の不調、肩こり、腰痛、眼精疲労でお困りの方へ。PNFストレッチ、パーソナルトレーニングで理想のカラダづくりをサポート。初心者大歓迎、入会金0円。"
        keywords="ストレッチ,パーソナルトレーニング,肩こり,腰痛,眼精疲労,いわき市,福島県,ボディケア,PNFストレッチ"
        ogTitle="ボディケア専門店H&K - 理想のカラダに。パーソナルストレッチ専門店"
        ogDescription="福島県いわき市のストレッチ専門店。身体の不調、肩こり、腰痛、眼精疲労でお困りの方へ。PNFストレッチ、パーソナルトレーニングで理想のカラダづくりをサポート。"
        ogUrl="/"
        canonicalUrl="/"
        jsonLd={jsonLd}
      />
      <div className="min-h-screen">
        <HeroSection />
        <ServicesSection />
        <PricingSection />
        <AboutSection />
      </div>
    </>
  );
}
